import classNames from 'classnames';
import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import LoadingIcon from '@/shared/components/LoadingLayer/LoadingIcon';

import NavBar from '@/shared/components/NavBar';

import styles from './index.module.scss';

type ModalProps = {
  readonly className?: string;
  readonly title?: string;
  readonly href?: string;
  readonly onClose: () => void;
};

const IframeModal = ({ className, title = '', href = '', onClose }: ModalProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => { setIsLoaded(false); }, [href]);

  return (
    <ReactModal
      shouldCloseOnEsc
      id="iframe-modal"
      role="dialog"
      isOpen={Boolean(href)}
      className={classNames(styles.modal, className)}
      overlayClassName={styles.overlay}
      closeTimeoutMS={300}
      onRequestClose={onClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <NavBar type="close" title={title} onClose={onClose} />
        </div>
        <div className={styles.content} aria-busy={!isLoaded}>
          {!isLoaded && <div className={styles.loader}><LoadingIcon /></div>}
          <iframe
            title={title}
            src={href}
            sandbox="allow-same-origin"
            className={classNames(styles.iframe, isLoaded && styles.loaded)}
            onLoad={() => {
              setIsLoaded(true);
            }}
            onError={() => {
              setIsLoaded(true);
            }}
          />
        </div>
      </div>
    </ReactModal>
  );
};

export default IframeModal;
